// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
// iui-utils
import { log, clearCookies, clearAutoLogoutTimer, clearCheckInactivityTimer, url } from '@insticator/insticator-ui'; 
// api
import * as ppa from './api/ppa'

// thunks
export const fetchUserPermissions = createAsyncThunk('session/fetchUserPermissions', async userUUID => {
    const response = await ppa.getUserPermissions(userUUID);
    return response.data
});

export const updateSelectedSite = createAsyncThunk('session/updateSelectedSite', async siteUUID => siteUUID);

export const signOut = () => dispatch => {
    clearUserSessionData(dispatch);
    // clear the timers on logout
    clearAutoLogoutTimer();
    clearCheckInactivityTimer();
    return ppa.userSignOutCall()
        .then(response => log('LOGOUT RESPONSE', response))
        .catch(error => log('LOGOUT NETWORK ERROR', error))
};

export const unmockUser = () => dispatch => {
    // clear the timers on unmock
    clearAutoLogoutTimer();
    clearCheckInactivityTimer();
    return ppa.unmockUserCall()
        .then(() => {
                window.location.replace(`${url.embed.url}/admin/login`);
            },
                error => {
                    log('UNMOCK NETWORK ERROR', error) ||
                    clearUserSessionData(dispatch);
            })
};

const clearUserSessionData = (dispatch) => {
    clearCookies([
        'account_uuid',
        'user_uuid',
        'session_source',
        'site_uuid',
        'embed_uuid',
        'product_category',
        'show_set_password',
        'show_terms_and_condition',
        'agreement_uuid'
    ]);
    window.open(`https://publisher.${url.baseURL}/auth/signin`, '_self')
};